import { PartnerEnquiry } from '../components/forms/PartnerEnquiry'

export default function RetailerEnquiryPage() {
  return <PartnerEnquiry kind="retailer" />
}
